<app-menu class="menuApp"></app-menu>
<div class="main">
  <div  style="width: 90%; margin: auto;">

    <div class="row">
      <div class="col-2" style="margin-top: 2vh" *ngIf="userService.getPermiso() == 'Administrador' && empresaSeleccionada != null">
        <mat-select class="upperButton textS" (ngModelChange)="changeEmpresa($event)" [(ngModel)]="empresaSeleccionada.nombre">
          <mat-option class="textS" *ngFor="let empresa of empresas" value="{{empresa.nombre}}">{{empresa.nombre}}</mat-option>
        </mat-select>
      </div>

      <div class="col-2" style="margin-top: 2vh" *ngIf="userService.getPermiso() == 'Administrador'">
        <button (click)="newEmpresa()" class="upperButton textS">{{this.localiser.get("users.newEnterprise")}}</button>
      </div>

      <div class="col-3" style="margin-top: 2vh" *ngIf="userService.getPermiso() == 'Administrador'">
        <button (click)="deleteCompany()" class="upperButton textS deleteButtonIn">
          <span class="button-text">{{ localiser.get("users.deleteCompany") }}</span>
          <span class="material-icons-outlined button-icon">delete</span>
        </button>
      </div>
    </div>

    <div class="row userSection" *ngIf="empresaSeleccionada != null">
      <div class="userHeader">
        <h1 class="centerVert textXXM">{{this.empresaSeleccionada.nombre}}</h1>
      </div>
      <div class="userTable" *ngIf="usuarios.length > 0">
        <table style="width:100%">
          <tr class="bottom-border">
            <th class="textS">{{this.localiser.get("profile.name")}}</th>
            <th class="textS">{{this.localiser.get("profile.surname")}}</th>
            <th class="textS">{{this.localiser.get("profile.email")}}</th>
            <th class="textS">{{this.localiser.get("profile.phone")}}</th>
            <th class="textS">{{this.localiser.get("profile.licenseExpiryDateMini")}}</th>
            <th class="textS">{{this.localiser.get("users.permissions")}}</th>
            <th class="textS">{{this.localiser.get("users.projects")}}</th>
            <th class="textS">{{this.localiser.get("users.actions")}}</th>
          </tr>
          <tr *ngFor="let usuario of usuarios" [ngClass]="{'thisUserRow': this.usuario.idUsuario == this.userService.getId()}">
            <td class="textS">{{usuario.nombre}}</td>
            <td class="textS">{{usuario.apellidos}}</td>
            <td class="textS">{{usuario.email}}</td>
            <td class="textS">{{usuario.telefono}}</td>
            <td class="textS">
              <mat-form-field style="width: 70%">
                <input matInput [matDatepicker]="picker" [(ngModel)]="usuario.licenseExpiryDate" (dateChange)="changeLicenseDate(usuario)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
            </td>
            <td>
              <mat-select class="textS" (ngModelChange)="changePermiso(usuario.idUsuario, $event)"
                            [(ngModel)]="usuario.idPermiso">
                <mat-option class="textS" value="Ateneo">{{this.localiser.get("users.ateneo")}}</mat-option>
                <mat-option class="textS" value="Configuración">{{this.localiser.get("users.configuration")}}</mat-option>
              </mat-select>
            </td>
            <td class="textS" (click)="changeProjects(usuario)" class="link">{{this.localiser.get("users.chooseProjects")}}</td>
            <td>
              <span *ngIf="usuario.idUsuario != userService.getId()" (click)="deleteUser(usuario)" class="textM material-icons-outlined deleteIcon verticalAlign">delete</span>
              <span (click)="resetPassword(usuario)" class="textM material-icons-outlined colorIcon verticalAlign">sync</span>
            </td>
          </tr>
        </table>
      </div>
      <div class="middleText" *ngIf="usuarios.length <= 0">
        <h3 class="textM centerVert">{{this.localiser.get("users.noUsers")}} {{this.empresaSeleccionada.nombre}}</h3>
      </div>
      <div class="row buttonsLine">
        <div class="col" style="text-align: center">
          <button (click)="newProyecto()" class="upperButton textS">{{this.localiser.get("users.newProject")}}</button>
        </div>
        <div *ngIf="userService.getPermiso() == 'Administrador'" class="col" style="text-align: center">
          <button (click)="deleteProject()" class="upperButton textS deleteButtonIn">
            <span class="button-text">{{ localiser.get("users.deleteProject") }}</span>
            <span class="material-icons-outlined button-icon">delete</span>
          </button>
        </div>
        <div class="col" style="text-align: center">
          <button (click)="newUser()" class="upperButton textS">{{this.localiser.get("users.newUser")}}</button>
        </div>
      </div>
    </div>

  </div>
</div>
